import { create } from 'zustand'
import { LeagueUpdateRespType } from 'types/league/leagueUpdates'

const leagueUpdatesStoreState = (set: any) => ({
  addUpdateModal: false,
  setAddUpdateModal: (state: boolean) =>
    set(() => ({ addUpdateModal: state })),

  editUpdateModal: false,
  setEditUpdateModal: (state: boolean) =>
    set(() => ({ editUpdateModal: state })),

  selectedUpdate: null as LeagueUpdateRespType | null,
  setSelectedUpdate: (state: LeagueUpdateRespType | null) =>
    set(() => ({ selectedUpdate: state })),
})

export const leagueUpdatesStore = create(leagueUpdatesStoreState)
